/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : requestToAddNewAddress.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Srinivas Grandhi (E528634)
*
* @Date         : AUG 2, 2019
*
* @Version      : Version 1.0
*
* By           : Srinivas Grandhi (E528634)
* On           : Sep 24, 2019
* Description  : Updated code as per ASDS-1282
*
* By           : H224423
* On           : Nov 11, 2019
* Description  : Back and close Redirection changes
*
* By           : Madhu Gali
* On           : Dec 18, 2019
* Description  : ASDS-584
*
* By            : Deepthi Bachu - E844276
* On            : 12 Mar, 2020
* Description   : Integration issue fixes
*
* By            : Suresh Jaladi - E807958
* On            : Mar 11, 2020
* Description   : ASDS-1766
*
* By            : H224423
* On            : Mar 30, 2020
* Description   : ASDS-2190, ASDS-2470 - Country service - Stopping loader and error on API failure. Enabled Retry option.
*
* By            : H422335
* On            : Oct 09, 2020
* Description   : ASDS-3035 Migration of backend URLs to Forge endpoints
*
* By            : H422335
* On            : Oct 27, 2020
* Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
******************************************************************************/

import * as React from 'react';
import { Select, Modal, Button, Input, Card, Notification } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './requestToAddNewAddress.css';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { getProperty } from 'utils/util';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import SelectAccount from '../SelectAccount/selectAccount';
import RouteConstants from '../constants/route-constants';
import { connect } from 'react-redux';
import RequestNewAddressAPI from '../API/requestNewAddress';
import NoticeRequestSuccessful from '../InlineNotificationComponent/InlineNotificationComponent';
import API from '../API/api';
import { handleResponse, checkUnauthorizedUserError } from '../API/apiUtils';
import { logError, logInfo } from '../../../utils/console-utility';
import InLineLoader from '../Loader/Loader';
import { ContactUsMessage } from '../Common/ContactUsMessage';

interface IrequestToAddNewAddressState {
    open: any;
    showNotificationPopup: boolean;
    notificationContent?: any;
    notificationType: string;
    notificationReturnCallBack?: Function;
    hasClickOut: any;
    error: string;
    fields: {
        [name: string]: any,
    };
    errors: {};
    countries: any[];
    states: any[];
    showSelectAccount: boolean;
    submitDisable:boolean;
    loading:boolean;
    isFetching: boolean; // for countries API
    isSuccess: boolean; // for countries API
}

interface IrequestToAddNewAddressProps {
    stateOptions?: any;
    content?: any;
    userValidationData: any;
    selectAccountDetails: any;
}

interface IcountryComponentProps {
    countries?: any[];
    setCountry: Function;
    error?: string;
}

interface IstateComponentProps {
    country: string;
    error?: string;
    setStateValue: Function;
}

interface IstateComponentState {
    states?: any[];
    country: string;
}

export const CountryComponent = (props: IcountryComponentProps | any) => {
    return (
        <React.Fragment>
            <div>
                <Select id='countryDropDown' label="Country" placeholder="Select Country" error={props.error || ''} indicator="required" options={props.countries || []} onChange={props.setCountry} search={true} />
            </div>
        </React.Fragment>
    );
};

export class StateComponent extends React.PureComponent<IstateComponentProps | any, IstateComponentState> {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps && prevState && nextProps.country !== prevState.country) {
            return {
                country: nextProps.country,
            };
        }
        return null;
    }

    constructor(props: IstateComponentProps) {
        super(props);
        this.state = {
            states: [],
            country: '',
        };
    }
    componentDidMount() {
        this.getStates();
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.country !== this.state.country) {
            this.componentDidMount();
        }
    }

    // Method to get States list from NGBSS service
    async getStates() {
        const url = CheckoutServiceURL.COUNTRY_URL + `?countryCode=${this.props.country}&fields=states`;
        let countryData: any = await API.get(url)
            .then(handleResponse)
            .catch(error => checkUnauthorizedUserError(error, 'Error while getting country states information '));

        let states: any[] = [];
        if (countryData && !countryData.code) {
            states = countryData.country.countries[0].states.map((e: any) => ({ value: e.stateCode, text: e.state }));
        }
        else {
            logError('Error while getting country states information.');
        }
        this.setState({
            states,
        });
    }

    render() {
        return (
            <React.Fragment>
                <div>
                    <Select label="State" placeholder="State" error={this.props.error || ''} indicator="required" options={this.state.states || []} onChange={this.props.setStateValue} />
                </div>
            </React.Fragment>
        );
    }
}

export class RequestToAddNewAddress extends React.Component<IrequestToAddNewAddressProps & RouteComponentProps, IrequestToAddNewAddressState> {

    setCompanyName: (value: string) => void;
    setAddressLine1: (value: string) => void;
    setAddressLine2: (value: string) => void;
    setCity: (value: string) => void;
    setPostalCode: (value: string) => void;
    setContactNumber: (value: string) => void;

    setCountry: (value: string) => void;
    setStateValue: (value: string) => void;

    constructor(props: IrequestToAddNewAddressProps & RouteComponentProps) {
        super(props);
        this.backFromNotificationPopup = this.backFromNotificationPopup.bind(this);
        this.state = {
            open: true,
            showNotificationPopup: false,
            hasClickOut: false,
            error: '',
            fields: {},
            errors: {},
            countries: [],
            states: [],
            showSelectAccount: false,
            notificationType: '',
            submitDisable:false,
            loading:false,
            isFetching: true,
            isSuccess: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.submitAddNewAddressForm = this.submitAddNewAddressForm.bind(this);
        this.setCompanyName = this.handleChange('companyName');
        this.setAddressLine1 = this.handleChange('addressLine1');
        this.setAddressLine2 = this.handleChange('addressLine2');
        this.setCity = this.handleChange('city');
        this.setPostalCode = this.handleChange('postalCode');
        this.setContactNumber = this.handleChange('contactNumber');
        this.toggleSelectAccount = this.toggleSelectAccount.bind(this);
        this.getCountries = this.getCountries.bind(this);

        this.setCountry = this.handleChange('country');
        this.setStateValue = this.handleChange('state');
    }

    componentDidMount() {
        this.getCountries();
    }

    // Method to get Country list
    async getCountries() {
        this.setState({
            isFetching: true,
            isSuccess: false,
            submitDisable: true
        });
        const url = CheckoutServiceURL.COUNTRY_URL;

        const countriesListData: any = await API.get(url)
            .then(handleResponse)
            .catch(error => checkUnauthorizedUserError(error, 'Error while getting country information '));

        if (countriesListData && !countriesListData.code) {
            // let countries: any[] = countriesListData.country.countries.map((e: any) => ({ value: e.countryCode, text: e.country }));
            let countries: any[] = countriesListData.country?.countries?.map((e: any) => ({ value: e.countryCode, text: e.country })) ?? [];
            this.setState({
                countries,
                isFetching: false,
                isSuccess: true,
                submitDisable: false
            });
        }
        else {
            logError('Error while getting country information.');
            this.setState({
                isFetching: false,
                isSuccess: false,
                submitDisable: true
            });
        }

    }

    handleChange = (name: string) => (value: string) => {
        this.setState(
            {
                fields: {
                    ...this.state.fields,
                    [name]: value,
                }
            },
            () => {
                const fieldValue = this.state.fields[name];
                if (fieldValue) {
                    this.setState({
                    errors: { ...this.state.errors, [name]: '' }
                });
            }
        });
    }

    async submitAddNewAddressForm(e) {
        this.setState({
            submitDisable: true,
            loading: true,
        })
        e.preventDefault();
        if (this.validateForm()) {
            const fields = { ...this.state.fields };
            logInfo(this.props.userValidationData);
            const { customer_sub: userId, email } = this.props.userValidationData.payload.userInfo;
            // create case
            const params = {
                userId,
                userEmailId: email,
                companyName: fields.companyName,
                addressLine1: fields.addressLine1,
                addressLine2: fields.addressLine2,
                country: fields.country,
                city: fields.city,
                state: fields.state,
                postalCode: fields.postalCode,
                contactNumber: fields.contactNumber,
            };
            await RequestNewAddressAPI.CallRequestNewAddressAPI(userId, params).then(data => {
                logInfo('Response :' + data);

                // If form is valid reset all form fields
                Object.entries(fields).forEach(entry => {
                    fields[entry[0]] = '';
                });
                this.setState({
                    fields,
                });
                if (data && data.caseNumber) {
                    const { caseNumber } = data;
                    this.setState({
                        submitDisable: false,
                        loading: false,
                        showNotificationPopup: true,
                        notificationType: 'success',
                        notificationContent: `Your request is submitted successfully ${caseNumber}. An account management representative will contact you within next 24-48 Hours.`
                    });
                } else {
                    this.setState({
                        submitDisable: false,
                        loading: false,
                        showNotificationPopup: true,
                        notificationType: 'failure',
                        notificationContent: <ContactUsMessage>Error occurred while processing your request. Please try again after sometime. If the issue persists, </ContactUsMessage>
                    });
                }
            }).catch ((error) => {
            logError('Save address error', error);
            this.setState({
                    submitDisable: false,
                    loading: false,
                    showNotificationPopup: true,
                    notificationType: 'failure',
                    notificationContent: <ContactUsMessage>Error occurred while processing your request. Please try again after sometime. If the issue persists, </ContactUsMessage>
                });
        });
        } else {
            this.setState({
                submitDisable: false,
                loading: false,
            });
        }

    }

    backFromNotificationPopup(loc: string) {
        const selectAccountDetails = this.props.selectAccountDetails;

        if (loc === 'close' && !selectAccountDetails.payload.customerName) {
            window.location.href = getProperty(CheckoutServiceURL.ADS_DASHBOARD_URL);
        }
    }

    // method to Display success message component
    redirectToSuccessPopUp() {
        this.props.history.push(RouteConstants.SUCCESS_MESSAGE);
    }

    // method to Display Select Account component
    toggleSelectAccount(loc: string) {
        this.setState(
            {
                showSelectAccount: !this.state.showSelectAccount,
                showNotificationPopup: false,
                open: false,
            },
            () => this.backFromNotificationPopup(loc));
    }

    // Method to validate all form fields
    validateForm() {
        let { companyName, addressLine1, addressLine2, city, postalCode, contactNumber, country, state } = this.state.fields;
        let errors = {};
        let formIsValid = true;

        errors['companyName'] = validateCompanyName(companyName);
        errors['addressLine1'] = validateAddress(addressLine1);

        if (typeof addressLine2 !== 'undefined' && '' !== addressLine2) {
            errors['addressLine2'] = validateAddress(addressLine2);
        }

        errors['city'] = validateCity(city);
        errors['postalCode'] = validatePostalCode(postalCode);
        errors['contactNumber'] = validateContactNumber(contactNumber);
        errors['country'] = validateCountry(country);

        if (country && (country === 'US' || country === 'CA')) {
            errors["state"] = validateState(state);
        }

        this.setState({
            errors: errors
        });
        Object.keys(errors).forEach(function (key) {
            if ('' !== errors[key]) {
                formIsValid = false;
            }
        });

        return formIsValid;
    }

    render() {
        return (
            <React.Fragment>
                {this.renderModal()}
            </React.Fragment>
        );
    }

    renderModal() {
        const honeywellId = this.props.userValidationData.payload.userInfo.customer_sub;
        logInfo('honeywellId ', honeywellId);

        if (this.state.showSelectAccount) {
            return (
                <SelectAccount open={true} onClose={() => this.toggleSelectAccount('close')} onContinue={() => this.toggleSelectAccount("")}/>
            );
        }
        if (this.state.showNotificationPopup) {
            return (
                <NoticeRequestSuccessful notificationContent={this.state.notificationContent} notificationType={this.state.notificationType} notificationReturnCallBack={() => this.backFromNotificationPopup('close')} />
            );
        }
        return (
            <Modal
                closeIcon={true}
                onClose={() => this.toggleSelectAccount('')}
                size="small"
                open={this.state.open}
                closeOnDimmerClick={this.state.hasClickOut}
                closeOnDocumentClick={this.state.hasClickOut}
                className="selectAccountModal request-new-address-modal"
            >
                <Modal.Header>
                    Request To Add New Address
                   </Modal.Header>
                <div className="box">
                <Modal.Content>
                {this.state.isFetching && <InLineLoader text="Fetching details..." loading={true} overlayColor="rgb(247, 247, 247)"className="request-address-loader" />}
                {!this.state.isFetching && !this.state.isSuccess &&
                <Notification
                    severity="critical"
                    hasIcon={true}
                    title="There is an error in processing your request."
                    detailsText="Retry"
                    onDetailsClick={this.getCountries}
                />
                }
                {this.state.loading && <InLineLoader text="Processing request..." loading={true} overlayColor='rgb(247, 247, 247)' />}
                    { (!this.state.isFetching && this.state.isSuccess) && !this.state.loading &&
                    <Card>
                        <Card.Content>
                            <div>
                                <Input className="input-example topMarginZero" label="Honeywell ID" placeholder="Enter Honeywell ID" disabled={true} value={honeywellId} />
                            </div>
                            <div>
                                <Input className="input-example" label="Company Name" error={this.state.errors['companyName']} placeholder="Enter Company Name" indicator="required" value={this.state.fields.companyName} onChange={this.setCompanyName} />
                            </div>
                            <div>
                                <Input className="input-example" label="Address Line 1" error={this.state.errors['addressLine1']} placeholder="Enter Address Line 1" indicator="required" value={this.state.fields.addressLine1} onChange={this.setAddressLine1} />
                            </div>
                            <div>
                                <Input className="input-example" label="Address Line 2" placeholder="Enter Address Line 2" error={this.state.errors['addressLine2']} value={this.state.fields.addressLine2} onChange={this.setAddressLine2} />
                            </div>
                            <div>
                                <CountryComponent countries={this.state.countries} setCountry={this.setCountry} error={this.state.errors['country']} />

                                {/* Display State Component If selected Country value is United States or Canada */}
                                {(this.state.fields.country === 'US' || this.state.fields.country === 'CA') && <StateComponent country={this.state.fields.country} error={this.state.errors['state']} setStateValue={this.setStateValue} />}
                            </div>
                            <div>
                                <Input className="input-example" label="City" placeholder="Enter City" indicator="required" error={this.state.errors['city']} value={this.state.fields.city} onChange={this.setCity} />
                            </div>
                            <div>
                                <Input className="input-example" label="Postal Code" pattern="[0-9]*" placeholder="Enter Postal Code" indicator="required" error={this.state.errors['postalCode']} value={this.state.fields.postalCode} onChange={this.setPostalCode} />
                            </div>
                            <div>
                                <Input className="input-example" label="Contact Number" placeholder="Enter Contact Number" indicator="required" error={this.state.errors['contactNumber']} value={this.state.fields.contactNumber} onChange={this.setContactNumber} />
                            </div>
                        </Card.Content>
                    </Card>
                    }
                    </Modal.Content>
                </div>
                <Modal.Footer>
                <div>
                        <Button id="backButton" type="secondary" content="Back" disabled={this.state.submitDisable} onClick={() => this.toggleSelectAccount('')} />
                        <Button id="SubmitButton" type="primary" disabled={this.state.submitDisable} size="medium" content="Submit" onClick={this.submitAddNewAddressForm} />
                </div>
                </Modal.Footer>
            </Modal>
        );

    }
}

// Method to Validate Company Name
export function validateCompanyName(companyName: string) {

    let errorMsg = '';

    if (!companyName) {
        errorMsg = 'Please enter a valid company name.';
    }

    else if (typeof companyName !== 'undefined') {
        if (!companyName.match(/^[a-z0-9\-.&()\"\s]+$/i)) {
            errorMsg = 'Please enter a valid company name. It can contain only (A-Z, a-z), digits (0-9), or the characters . - & ( ) "';
        }
        if (companyName.length > 200) {
            errorMsg = 'Please enter a valid company name. It can contain upto 200 characters';
        }
    }

    return errorMsg;
}

// Method to Validate Address Line 1 & 2
export function validateAddress(address: string) {

    let errorMsg = '';

    if (!address) {
        errorMsg = 'Please enter a valid address.';
    }

    else if (typeof address !== 'undefined') {
        if (!address.match(/^[a-z0-9\-.&()\"\s]+$/i)) {
            errorMsg = 'Please enter a valid address. It can contain only (A-Z, a-z), digits (0-9), or the characters . - & ( ) "';
        }
        if (address.length > 200) {
            errorMsg = 'Please enter a valid address. It can contain upto 200 characters';
        }
    }

    return errorMsg;
}

// Method to Validate City
export function validateCity(city: string) {

    let errorMsg = '';

    if (!city) {
        errorMsg = 'Please enter a valid city.';
    }

    else if (typeof city !== 'undefined') {
        if (!city.match(/^[a-z0-9\s]+$/i)) {
            errorMsg = 'Please enter a valid city. It can contain only (A-Z, a-z)';
        }
        if (city.length > 80) {
            errorMsg = 'Please enter a valid city. It can contain upto 80 characters';
        }
    }

    return errorMsg;
}

// Method to Validate Postal Code
export function validatePostalCode(postalCode: string) {

    let errorMsg = '';

    if (!postalCode) {
        errorMsg = 'Please enter a valid postal code.';
    }

    else if (typeof postalCode !== 'undefined') {
        if (!postalCode.match(/^[a-z0-9\s]+$/i)) {
            errorMsg = 'Please enter a valid postal code. It can contain only (A-Z, a-z), digits (0-9)';
        }
        if (postalCode.length > 80) {
            errorMsg = 'Please enter a valid postal code. It can contain upto 80 characters';
        }
    }

    return errorMsg;
}

// Method to Validate Contact Number
export function validateContactNumber(contactNumber: string) {

    let errorMsg = '';

    if (!contactNumber) {
        errorMsg = 'Please enter a valid contact number.';
    }

    else if (typeof contactNumber !== 'undefined') {
        if (!contactNumber.match(/^[0-9]+$/i)) {
            errorMsg = 'Please enter a valid contact number. It contain only contain digits (0-9)';
        }
        if (contactNumber.length > 80) {
            errorMsg = 'Please enter a valid contact number. It can contain upto 80 characters';
        }
    }

    return errorMsg;
}

// Method to Validate Country
export function validateCountry(country: string) {

    let errorMsg = '';

    if (!country) {
        errorMsg = 'Please select country.';
    }

    return errorMsg;
}

// Method to Validate State
export function validateState(state: string) {

    let errorMsg = '';

    if (!state) {
        errorMsg = 'Please select state.';
    }

    return errorMsg;
}

function mapStateToProps(state) {
    return {
        userValidationData: state.userValidationData,
        selectAccountDetails: state.selectAccount.selectAccountDetails,
    };
}

export default connect(mapStateToProps, {})(withRouter(RequestToAddNewAddress));